import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { useFlowDisplayLanguage } from '../../displayLanguage';
import {
  DEFAULT_SOUND_EFFECT,
  getSoundEffectLabel,
  isSoundEffect,
  SOUND_EFFECTS,
} from '../../config/soundEffects';

export function SoundEffectSettings({ node }: NodeSettingsProps<'soundEffect'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();
  const sound = isSoundEffect(node.data.sound) ? node.data.sound : DEFAULT_SOUND_EFFECT;

  return (
    <label className="block" data-product-tour="card-input-1">
      <span className="mb-1 block text-sm font-medium text-slate-700">
        {displayLanguage === 'en' ? 'sound' : '効果音'}
      </span>
      <select
        value={sound}
        onChange={(event) => {
          if (isSoundEffect(event.target.value)) {
            updateNodeData(node.id, { sound: event.target.value });
          }
        }}
        className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-orange-400"
      >
        {SOUND_EFFECTS.map((option) => (
          <option key={option} value={option}>
            {getSoundEffectLabel(option, displayLanguage)}
          </option>
        ))}
      </select>
    </label>
  );
}
